export default __webpack_public_path__ + "static/appleWalletGraphic-01d24d90b727b123cb6cf72eec78570c.svg";